/**
 * @fileoverview POST handler for the "/companies/:company_id/mobile_app_linking_configs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postCompaniesCompanyIdMobileAppLinkingConfigsCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdMobileAppLinkingConfigsProps,
  PostCompaniesCompanyIdMobileAppLinkingConfigsResult,
} from "./types";

export const postCompaniesCompanyIdMobileAppLinkingConfigs = reactQueryMutationAdapter(
  postCompaniesCompanyIdMobileAppLinkingConfigsCacheKeys,
  ({
    companyId,
    name,
    iosConfig,
    androidConfig,
  }: PostCompaniesCompanyIdMobileAppLinkingConfigsProps): Promise<PostCompaniesCompanyIdMobileAppLinkingConfigsResult> => {
    return fetch(
      `/companies/${companyId}/mobile_app_linking_configs`,
      "POST",
      {
        name,
        // Wire params are snake_case (house rule; matches the assignments endpoints).
        // The payload documents themselves are free-form and pass through untouched.
        ios_config: iosConfig && { enabled: iosConfig.enabled, aasa_payload: iosConfig.aasaPayload },
        android_config: androidConfig && {
          enabled: androidConfig.enabled,
          assetlinks_payload: androidConfig.assetlinksPayload,
        },
      },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
